import styled from 'styled-components';
import { Theme } from '@/theme';
import SkewTopIcon from '@CS/assets/Login/skew_top_box_icon.svg';

export const LoginScreen = styled.section`
  padding: 8vmin 24px;
  text-align: center;
`;

export const Logo = styled.img`
  height: auto;
  width: 174px;
  margin-bottom: -220px;
  transform: translateX(-25px);

  @media (min-width: 340px) {
    margin-bottom: -184px;
    margin-top: 38px;
    transform: translateX(-25px);
  }
`;

export const InfoContainer = styled.div`
  color: rgb(255 255 255);
  text-align: center;
  position: relative;
  z-index: 2;
`;

export const Title = styled.h1`
  border: 0.5px solid ${Theme.color.white};
  text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.6);
  color: #ffbc0d;
  font-weight: 700;
  font-size: 30px;
  line-height: 110%;
  margin-bottom: 5px;
  text-align: center;

  @media (min-width: 360px) {
    font-size: 34px;
  }
`;

export const Text = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #151515;
  text-align: center;
  margin-bottom: 30px;
`;

export const Box = styled.div`
  position: relative;
  z-index: 2;
  background-color: #fff;
  padding: 3px 22px clamp(22px, 5.8vw, 30px);
  border-radius: 0px 0px 24px 24px;

  &::before {
    content: '';
    display: block;
    background: url(${SkewTopIcon}) no-repeat;
    background-size: 100%;
    padding-top: 13.7%;
    position: absolute;
    width: 100%;
    left: 0px;
    top: 0px;
    transform: translateY(-98%);
  }
`;
